/**
 * Enum de status.
 */
export const status = {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
};

/**
 * Enum de níveis.
 */
export const level = {
  SuperAdmin: 'super-admin',
  Admin: 'admin',
  Operator: 'operator',
  Viewer: 'viewer',
  Custom: 'custom',
};
